import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProductDetailsContext } from '../context';
import { messages } from '../messages';

import style from '../style.module.less';

export const ProductDetailsSubHeaderMessage = () => {
  const { isVariant, currentProductProfile, parentProduct } = useContext(ProductDetailsContext);
  const { name: productProfileName } = currentProductProfile;

  if (isVariant || productProfileName) {
    return (
      <div className={style['sub-header']}>
        <FontAwesomeIcon className={style.information} icon={faInfoCircle} />
        {isVariant && (
          <div>
            <FormattedMessage
              {...messages.subHeaderVariant}
              values={{
                name: <b>{parentProduct.name}</b>,
                sku: <b>{parentProduct.sku}</b>,
              }}
            />
          </div>
        )}
        {isVariant && productProfileName && <span>&nbsp;</span>}
        {productProfileName && (
          <div>
            <FormattedMessage {...messages.subHeaderPreset} values={{ name: <b>{productProfileName}</b> }} />
          </div>
        )}
      </div>
    );
  }
  return null;
};
